import React from 'react';
import { CTA } from '../CTA';
export const ServicesPage = () => {
  return <div className="w-full bg-white" data-id="element-247">
      {/* Services Header */}
      <section className="py-20 bg-white" data-id="element-248">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-249">
          <h2 className="text-base text-green-600 font-semibold tracking-wide uppercase mb-2" data-id="element-250">
            SERVICES
          </h2>
          <p className="text-4xl font-bold mb-4 text-[#2c3e50]" data-id="element-251">
            Copy That Actually Works
          </p>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-252">
            Stop losing customers to boring copy. We don't just write words. We
            write revenue-generating machines disguised as copy.
          </p>
        </div>
      </section>
      {/* Services Grid - 6 columns */}
      <section className="py-10" data-id="element-253">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-255">
            {/* First Row */}
            {/* Email Campaigns */}
            <div className="bg-white p-4 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 border border-gray-100" data-id="element-256">
              <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center text-white text-xl mb-3" data-id="element-257">
                📧
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#2c3e50]" data-id="element-258">
                Email Campaigns
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-259">
                Strategic sequences that turn subscribers into buyers.
              </p>
              <div className="bg-gray-50 rounded-xl p-3 mb-2" data-id="element-260">
                <h4 className="text-sm font-bold text-[#2c3e50] mb-2" data-id="element-261">
                  What You Get:
                </h4>
                <ul className="space-y-1" data-id="element-262">
                  <li className="flex items-start gap-2 text-sm" data-id="element-263">
                    <span className="text-green-600 font-bold" data-id="element-264">✓</span>
                    <span className="text-gray-600" data-id="element-265">Welcome sequences</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-266">
                    <span className="text-green-600 font-bold" data-id="element-267">✓</span>
                    <span className="text-gray-600" data-id="element-268">Sales funnels</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-269">
                    <span className="text-green-600 font-bold" data-id="element-270">✓</span>
                    <span className="text-gray-600" data-id="element-271">Retention campaigns</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Brand Messaging */}
            <div className="bg-white p-4 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 border border-gray-100" data-id="element-272">
              <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center text-white text-xl mb-3" data-id="element-273">
                🎯
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#2c3e50]" data-id="element-274">
                Brand Messaging
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-275">
                Strategic brand positioning that sets you apart from
                competitors.
              </p>
              <div className="bg-gray-50 rounded-xl p-3 mb-2" data-id="element-276">
                <h4 className="text-sm font-bold text-[#2c3e50] mb-2" data-id="element-277">
                  What You Get:
                </h4>
                <ul className="space-y-1" data-id="element-278">
                  <li className="flex items-start gap-2 text-sm" data-id="element-279">
                    <span className="text-green-600 font-bold" data-id="element-280">✓</span>
                    <span className="text-gray-600" data-id="element-281">Brand positioning</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-282">
                    <span className="text-green-600 font-bold" data-id="element-283">✓</span>
                    <span className="text-gray-600" data-id="element-284">Voice guidelines</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-285">
                    <span className="text-green-600 font-bold" data-id="element-286">✓</span>
                    <span className="text-gray-600" data-id="element-287">Competitor analysis</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Sales Pages */}
            <div className="bg-white p-4 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 border border-gray-100" data-id="element-288">
              <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center text-white text-xl mb-3" data-id="element-289">
                📊
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#2c3e50]" data-id="element-290">
                Sales Pages
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-291">
                High-converting sales pages that guide prospects to purchase.
              </p>
              <div className="bg-gray-50 rounded-xl p-3 mb-2" data-id="element-292">
                <h4 className="text-sm font-bold text-[#2c3e50] mb-2" data-id="element-293">
                  What You Get:
                </h4>
                <ul className="space-y-1" data-id="element-294">
                  <li className="flex items-start gap-2 text-sm" data-id="element-295">
                    <span className="text-green-600 font-bold" data-id="element-296">✓</span>
                    <span className="text-gray-600" data-id="element-297">Long-form sales pages</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-298">
                    <span className="text-green-600 font-bold" data-id="element-299">✓</span>
                    <span className="text-gray-600" data-id="element-300">Multi-step funnels</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-301">
                    <span className="text-green-600 font-bold" data-id="element-302">✓</span>
                    <span className="text-gray-600" data-id="element-303">Upsell sequences</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Second Row */}
            {/* Marketing Content */}
            <div className="bg-white p-4 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 border border-gray-100" data-id="element-304">
              <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center text-white text-xl mb-3" data-id="element-305">
                📱
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#2c3e50]" data-id="element-306">
                Marketing Content
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-307">
                Social posts, ads, and sales materials that drive results.
              </p>
              <div className="bg-gray-50 rounded-xl p-3 mb-2" data-id="element-308">
                <h4 className="text-sm font-bold text-[#2c3e50] mb-2" data-id="element-309">
                  What You Get:
                </h4>
                <ul className="space-y-1" data-id="element-310">
                  <li className="flex items-start gap-2 text-sm" data-id="element-311">
                    <span className="text-green-600 font-bold" data-id="element-312">✓</span>
                    <span className="text-gray-600" data-id="element-313">Engaging social media</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-314">
                    <span className="text-green-600 font-bold" data-id="element-315">✓</span>
                    <span className="text-gray-600" data-id="element-316">Authority blog posts</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-317">
                    <span className="text-green-600 font-bold" data-id="element-318">✓</span>
                    <span className="text-gray-600" data-id="element-319">Voice guidelines</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Ad Copy */}
            <div className="bg-white p-4 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 border border-gray-100" data-id="element-320">
              <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center text-white text-xl mb-3" data-id="element-321">
                📢
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#2c3e50]" data-id="element-322">Ad Copy</h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-323">
                Attention-grabbing, click-worthy ad copy that delivers ROI.
              </p>
              <div className="bg-gray-50 rounded-xl p-3 mb-2" data-id="element-324">
                <h4 className="text-sm font-bold text-[#2c3e50] mb-2" data-id="element-325">
                  What You Get:
                </h4>
                <ul className="space-y-1" data-id="element-326">
                  <li className="flex items-start gap-2 text-sm" data-id="element-327">
                    <span className="text-green-600 font-bold" data-id="element-328">✓</span>
                    <span className="text-gray-600" data-id="element-329">Social media ads</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-330">
                    <span className="text-green-600 font-bold" data-id="element-331">✓</span>
                    <span className="text-gray-600" data-id="element-332">Google Ads copy</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-333">
                    <span className="text-green-600 font-bold" data-id="element-334">✓</span>
                    <span className="text-gray-600" data-id="element-335">A/B testing</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Website Copy */}
            <div className="bg-white p-4 rounded-xl shadow-lg transition-transform duration-300 hover:-translate-y-2 border border-gray-100" data-id="element-336">
              <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center text-white text-xl mb-3" data-id="element-337">
                🌐
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#2c3e50]" data-id="element-338">
                Website Copy
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-339">
                Headlines that hook, pages that convert visitors into customers.
              </p>
              <div className="bg-gray-50 rounded-xl p-3 mb-2" data-id="element-340">
                <h4 className="text-sm font-bold text-[#2c3e50] mb-2" data-id="element-341">
                  What You Get:
                </h4>
                <ul className="space-y-1" data-id="element-342">
                  <li className="flex items-start gap-2 text-sm" data-id="element-343">
                    <span className="text-green-600 font-bold" data-id="element-344">✓</span>
                    <span className="text-gray-600" data-id="element-345">Converting headlines</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-346">
                    <span className="text-green-600 font-bold" data-id="element-347">✓</span>
                    <span className="text-gray-600" data-id="element-348">Trust-building pages</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm" data-id="element-349">
                    <span className="text-green-600 font-bold" data-id="element-350">✓</span>
                    <span className="text-gray-600" data-id="element-351">Irresistible CTAs</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-20 bg-gray-50" data-id="element-352">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-353">
          <div className="text-center mb-16" data-id="element-354">
            <h2 className="text-4xl font-bold text-[#2c3e50] mb-4" data-id="element-355">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-gray-600" data-id="element-356">
              Everything you need to know about our services
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-357">
            <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-358">
              <h4 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-359">
                How long does each project take?
              </h4>
              <p className="text-gray-600" data-id="element-360">
                Most projects are completed within 7-14 days. Email campaigns
                take 1-2 weeks, website copy takes 2-3 weeks, and ad copy can be
                delivered in 3-5 days.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-361">
              <h4 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-362">
                Do you work with our industry?
              </h4>
              <p className="text-gray-600" data-id="element-363">
                We work across all industries. If you sell to humans, we can
                write copy that converts them. Our process adapts to any
                business model or market.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-364">
              <h4 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-365">
                What if we don't like the copy?
              </h4>
              <p className="text-gray-600" data-id="element-366">
                We offer unlimited revisions until you're completely satisfied.
                Our goal is your success, and we'll work until we achieve it
                together.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-367">
              <h4 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-368">
                Can you guarantee results?
              </h4>
              <p className="text-gray-600" data-id="element-369">
                While we can't guarantee specific numbers (too many variables),
                we do guarantee you'll see improved performance. Our track
                record speaks for itself.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-370">
              <h4 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-371">
                Do you provide strategy or just copy?
              </h4>
              <p className="text-gray-600" data-id="element-372">
                Every project includes strategic thinking. We don't just write
                words - we develop messaging strategies that align with your
                business goals.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-373">
              <h4 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-374">
                How do we get started?
              </h4>
              <p className="text-gray-600" data-id="element-375">
                Book a strategy call where we'll discuss your goals, challenges,
                and how our copy can help. From there, we'll create a custom
                proposal for your needs.
              </p>
            </div>
          </div>
        </div>
      </section>
      <CTA data-id="element-376" />
    </div>;
};